import * as Sentry from "@sentry/react";

// Errors that we don't want to report to Sentry
const ignoredErrors = [
  // Network errors are expected to happen and there is no added value in reporting them
  "network error",
  "A network error occurred",
  "sw.js load failed",
  // Auth0 token errors are expected to happen and there is no added value in reporting them
  "Missing Refresh Token",
  "invalid refresh token",
];

export const initializeSentry = (tenantName: string | undefined) => {
  if (import.meta.env.VITE_ENVIRONMENT !== "local") {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN as string,
      integrations: [
        new Sentry.Replay({
          maskAllInputs: true,
          maskAllText: false,
          blockAllMedia: false,
          networkDetailAllowUrls:
            import.meta.env.VITE_ENVIRONMENT !== "production"
              ? [/^https:\/\/(app|api)(\.\w+)?\.m7health\.(dev|com)/]
              : [],
        }),
      ],
      ignoreErrors: ignoredErrors,
      environment: import.meta.env.VITE_ENVIRONMENT as string,
      release: import.meta.env.VITE_APP_VERSION as string,
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 1.0,
    });
    if (tenantName) {
      Sentry.setTag("tenantName", tenantName);
    }
  }
};
